<template>
  <Head>
    <title>Согласие на обработку персональных данных {{ $titleEnd }}</title>
    <meta
      name="description"
      content="Ознакомиться с согласием на обработку персональных данных жилого комплекса «Сенсация» в Чите от ГК Основа."
    />
    <meta
      property="og:title"
      :content="'Согласие на обработку персональных данных ' + $titleEnd"
    />
    <meta
      property="og:description"
      content="Ознакомиться с согласием на обработку персональных данных жилого комплекса «Сенсация» в Чите от ГК Основа."
    />
  </Head>
  <main class="main">
    <div class="container">
      <Breadcrumbs
        :links="[
          { name: 'Home', text: 'Главная' },
          { text: 'Согласие на обработку персональных данных' },
        ]"
      />
      <h1 class="page-title h2">Согласие на обработку персональных данных</h1>
      <p>
        Я даю согласие Акционерному обществу «ГК ОСНОВА», зарегистрированного по
        адресу: 142702, Московская обл., город Видное, поселок городского типа
        Бутово, территория жилой комплекс Бутово-Парк, д. 18, пом. 59 (далее -
        Оператор) на обработку своих персональных данных на следующих условиях:
      </p>
      <p><b>Цели обработки Персональных данных:</b></p>
      <p>
        - идентификация, создания учетной записи;<br />
        - проведение Оператором маркетинговых исследований, опросов по качеству
        обслуживания, прочих опросов;
        <br />
        - организация стимулирующих мероприятий (акции, конкурсы и пр.) и
        программы лояльности Оператора;
        <br />- анализ информации, хранимой в файлах cookies;<br />-
        совершенствование и развитие деятельности Оператора;<br />
        - оказание информационных, справочных и консультационных услуг в рамках
        телефонного обслуживания;
        <br />
        - обработку, рассмотрение поступающих обращений, предоставление
        эффективной поддержки при возникновении проблем.
      </p>

      <p><b>Перечень обрабатываемых персональных данных:</b></p>
      <p>
        - фамилия, имя, отчество;<br />
        - контактные данные (номер телефона, адрес электронной почты, псевдоним
        (идентификатор) в социальных сетях и сервисах коммуникаций);
        <br />- электронные пользовательские данные (файлы cookies).
      </p>

      <p>
        <b>Действия с персональными данными:</b> автоматизированная и
        неавтоматизированная (смешанная) обработка посредством осуществления
        следующих действий: сбор, запись, систематизация, накопление, хранение,
        уточнение (обновление, изменение), извлечение, использование,
        обезличивание, передача (предоставление, доступ), блокирование,
        удаление, уничтожение.
      </p>

      <p>
        <b>Сроки обработки персональных данных:</b> с момента предоставления
        настоящего согласия до достижения целей обработки или до отзыва
        согласия.
      </p>

      <p>
        <b>Порядок отзыва:</b> настоящее Согласие может быть отозвано мной в
        любой момент времени, путем направления письменного запроса в адрес
        Оператора или на электронную почту:
        <a href="mailto:info@gk-osnova.ru">info@gk-osnova.ru</a>.
      </p>

      <p>
        Настоящее согласие имеет юридическую силу, считается заполненным и
        является подписанным с момента заполнения формы путем принятия условий и
        проставления графического элемента согласия («галочки» в соответствующем
        чек-боксе), являющегося заменой собственноручной подписи.
      </p>

      <p>
        Политика обработки персональных данных расположена по адресу:
        <a href="/Политика_обработки_персональных_данных.pdf" target="_blank"
          >https://zk-sensation.ru/Политика_обработки_персональных_данных.pdf</a
        >.
      </p>
    </div>
  </main>
</template>
<script>
import Breadcrumbs from "@/components/UI/Breadcrumbs.vue";
import { Head } from "@vueuse/head";
export default {
  components: {
    Head,
    Breadcrumbs,
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.page-title.h2 {
  @media (max-width: 575px) {
    font-size: 38px;
  }
}
</style>